/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.221.0-v202611032344-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqContentApiClass {
 
   constructor() {}

  /**
   * @summary Archive an asset selection
   * @param {string} id - The Seeq ID for the asset selection
  */
  public archiveAssetSelection(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/asset-selections/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/asset-selections/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive a content item
   * @param {string} id - The Seeq ID for the content
  */
  public archiveContent(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive a date range
   * @param {string} id - The Seeq ID for the date range
  */
  public archiveDateRange(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/date-ranges/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/date-ranges/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Archive a row selection
   * @param {string} id - The Seeq ID for the row selection
  */
  public archiveRowSelection(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/row-selections/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/row-selections/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Clear the cached images for a piece of content
   * @param {string} id - The Seeq ID for the content
  */
  public clearImageCache(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/${encodeURIComponent(String(id))}/image`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/{id}/image`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Create new asset selection
  */
  public createAssetSelection(
    body: models.AssetSelectionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/asset-selections`;
    const urlTemplate = `${baseUrl}/content/asset-selections`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AssetSelectionOutputV1>;
  }

  /**
   * @summary Create a new content item
  */
  public createContent(
    body: models.ContentInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content`;
    const urlTemplate = `${baseUrl}/content`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ContentOutputV1>;
  }

  /**
   * @summary Create a new date range
  */
  public createDateRange(
    body: models.DateRangeInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/date-ranges`;
    const urlTemplate = `${baseUrl}/content/date-ranges`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DateRangeOutputV1>;
  }

  /**
   * @summary Create new row selection
  */
  public createRowSelection(
    body: models.RowSelectionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/row-selections`;
    const urlTemplate = `${baseUrl}/content/row-selections`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.RowSelectionOutputV1>;
  }

  /**
   * @summary Get an asset selection
   * @param {string} id - The Seeq ID for the asset selection
  */
  public getAssetSelection(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/asset-selections/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/asset-selections/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AssetSelectionOutputV1>;
  }

  /**
   * @summary Get a content item
   * @param {string} id - The Seeq ID for the content
  */
  public getContent(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ContentOutputV1>;
  }

  /**
   * @summary Get content items
   * @param {number} [offset=0] - The pagination offset, the index of the first content item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of content items that will be returned in this page of results
  */
  public getContentItems(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content`;
    const urlTemplate = `${baseUrl}/content`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetContentItemsOutputV1>;
  }

  /**
   * @summary Get the content items that depend on a given date range
   * @param {string} id - The Seeq ID for the date range
   * @param {number} [offset=0] - The pagination offset, the index of the first content item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of content items that will be returned in this page of results
  */
  public getContentItemsForDateRange(
    {
      id,
      offset,
      limit
    } : {
      id: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/date-ranges/${encodeURIComponent(String(id))}/content`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/date-ranges/{id}/content`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetContentItemsOutputV1>;
  }

  /**
   * @summary Retrieves all pieces of content and date ranges associated with the given report with extra metadata attached
   * @param {string} reportId - Report to retrieve content and date ranges for
   * @param {boolean} [includeWorkstepBlobs=false] - Set to true to include the source and workstep blobs in the output
  */
  public getContentsWithAllMetadata(
    {
      reportId,
      includeWorkstepBlobs
    } : {
      reportId: string,
      includeWorkstepBlobs?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (reportId === null || reportId === undefined) {
      throw new Error("'reportId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/report/${encodeURIComponent(String(reportId))}`
      .replace('{reportId}', encodeURIComponent(String(reportId)));
    const urlTemplate = `${baseUrl}/content/report/{reportId}`;

    const queryParams = {
      ['includeWorkstepBlobs']: includeWorkstepBlobs
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ContentWithMetadataListOutputV1>;
  }

  /**
   * @summary Get a date range
   * @param {string} id - The Seeq ID for the date range
  */
  public getDateRange(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/date-ranges/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/date-ranges/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.DateRangeOutputV1>;
  }

  /**
   * @summary Get date range items
   * @param {number} [offset=0] - The pagination offset, the index of the first date range that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of date ranges that will be returned in this page of results
  */
  public getDateRanges(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/date-ranges`;
    const urlTemplate = `${baseUrl}/content/date-ranges`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetDateRangesOutputV1>;
  }

  /**
   * @summary Get the image from a piece of content
   * @param {string} id - The Seeq ID for the content
   * @param {boolean} [useAsync=false] - When true, if the image is not cached a one pixel image will be returned from this call and a job will be started to generate the new image. Used to avoid blocking requests when called from a browser context.
  */
  public getImage(
    {
      id,
      useAsync
    } : {
      id: string,
      useAsync?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/${encodeURIComponent(String(id))}/image`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/{id}/image`;

    const queryParams = {
      ['useAsync']: useAsync
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Retrieves all reports that have notifications configured
   * @param {Array<string>} [ownerIds]
   * @param {string} [nameSearch] - Filter the reports to those that are part of a topic document with the provided name
   * @param {number} [offset=0] - The pagination offset, the index of the first reports that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of reports that will be returned in this page of results
   * @param {boolean} [sortAsc=true] - Sorts the document name in ascending order when true and descending when false
   * @param {boolean} [enabledFilter] - Filter reports by their enabled status
  */
  public getNotifiableReports(
    {
      ownerIds,
      nameSearch,
      offset,
      limit,
      sortAsc,
      enabledFilter
    } : {
      ownerIds?: Array<string>,
      nameSearch?: string,
      offset?: number,
      limit?: number,
      sortAsc?: boolean,
      enabledFilter?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/notifiableReports`;
    const urlTemplate = `${baseUrl}/content/notifiableReports`;

    const queryParams = {
      ['ownerIds']: ownerIds,      ['nameSearch']: nameSearch,      ['offset']: offset,      ['limit']: limit,      ['sortAsc']: sortAsc,      ['enabledFilter']: enabledFilter
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.NotifiableReportOutputListV1>;
  }

  /**
   * @summary Get the react json blob for a piece of content
   * @param {string} id - The Seeq ID for the content
  */
  public getReactBlob(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/${encodeURIComponent(String(id))}/react`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/{id}/react`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<any>;
  }

  /**
   * @summary Production status of the Analyses embedded in a document. Names are omitted for sources the caller cannot read.
   * @param {string} reportId - Report whose content sources are classified. The caller must be able to read it.
  */
  public getReportProductionStatus(
    {
      reportId
    } : {
      reportId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (reportId === null || reportId === undefined) {
      throw new Error("'reportId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/report/${encodeURIComponent(String(reportId))}/production-status`
      .replace('{reportId}', encodeURIComponent(String(reportId)));
    const urlTemplate = `${baseUrl}/content/report/{reportId}/production-status`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ReportProductionStatusOutputV1>;
  }

  /**
   * @summary Get a row selection
   * @param {string} id - The Seeq ID for the row selection
  */
  public getRowSelection(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/row-selections/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/row-selections/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.RowSelectionOutputV1>;
  }

  /**
   * @summary Gets a collection of statistics for scheduled items
   * @param {Array<string>} types - List of types to filter on
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {string} [sortBy=AverageRunTime] - A field by which to order the items&#x27;. Options: AverageRunTime, TotalRunTime, Name, Username, ContentCount, LastViewedAt, NextRunTime. Note: sorting by NextRunTime may be significantly slower than other options.
   * @param {boolean} [sortAsc=true] - If true or blank, sorts ascending. If false sorts descending.
   * @param {boolean} [isEnabled=true] - If true, includes only items with enabled schedules. If false, includes only items with disabled schedules.
   * @param {string} [nameFilter] - The topic/worksheet name to filter on.
   * @param {string} [ownerFilter] - The owner username to filter on.
   * @param {string} [scheduleFilter] - The schedule text to filter on.
  */
  public getSchedulableStatistics(
    {
      types,
      offset,
      limit,
      sortBy,
      sortAsc,
      isEnabled,
      nameFilter,
      ownerFilter,
      scheduleFilter
    } : {
      types: GetSchedulableStatisticsTypesEnum[],
      offset?: number,
      limit?: number,
      sortBy?: GetSchedulableStatisticsSortByEnum,
      sortAsc?: boolean,
      isEnabled?: boolean,
      nameFilter?: string,
      ownerFilter?: string,
      scheduleFilter?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (types === null || types === undefined) {
      throw new Error("'types' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/schedulable/metrics`;
    const urlTemplate = `${baseUrl}/content/schedulable/metrics`;

    const queryParams = {
      ['types']: types,      ['offset']: offset,      ['limit']: limit,      ['sortBy']: sortBy,      ['sortAsc']: sortAsc,      ['isEnabled']: isEnabled,      ['nameFilter']: nameFilter,      ['ownerFilter']: ownerFilter,      ['scheduleFilter']: scheduleFilter
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.SchedulableAdminListOutputV1>;
  }

  /**
   * @summary Gets a summary of statistics for scheduled items across a week, with each day being separated into 24 buckets
   * @param {string} start - The ISO Date string to start the summary from. The time must start at midnight on some day
   * @param {string} [stat=AverageRunTime] - The stat to summarize by
   * @param {string} [ownerFilter] - The owner username to filter on.
  */
  public getSchedulableSummary(
    {
      start,
      stat,
      ownerFilter
    } : {
      start: string,
      stat?: GetSchedulableSummaryStatEnum,
      ownerFilter?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (start === null || start === undefined) {
      throw new Error("'start' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/schedulable/metrics/summary`;
    const urlTemplate = `${baseUrl}/content/schedulable/metrics/summary`;

    const queryParams = {
      ['stat']: stat,      ['start']: start,      ['ownerFilter']: ownerFilter
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.SchedulableSummaryWeekOutputV1>;
  }

  /**
   * @summary Preview an image for given content parameters
   * @param {string} worksheetId - The content&#x27;s source worksheet
   * @param {string} workstepId - The content&#x27;s source workstep
   * @param {number} height - The content&#x27;s desired height
   * @param {number} width - The content&#x27;s desired width
   * @param {number} [scale=1.0] - The content&#x27;s desired scale
   * @param {string} [timezone] - The content&#x27;s desired timezone
   * @param {string} [selector] - The content&#x27;s desired selector
   * @param {string} [dateRangeId] - The content&#x27;s date range; mutually exclusive with dateRangeFormula
   * @param {string} [dateRangeFormula] - Formula used as a temporary date range; mutually exclusive with dateRangeId
   * @param {string} [validityDuration] - A duration to use as the Expires header
   * @param {string} [reportId] - The content&#x27;s report
   * @param {string} [contentId] - The content&#x27;s ID
   * @param {string} [summaryType] - The content&#x27;s desired summary type
   * @param {string} [summaryValue] - The content&#x27;s desired summary value
   * @param {string} [assetSelectionId] - The content&#x27;s asset selection id
   * @param {boolean} [react] - Whether the content is for a react component
   * @param {boolean} [hideUncertainty] - Whether uncertainty indicators should be hidden
   * @param {boolean} [showUncertainty] - Whether uncertainty indicators should be shown, overriding the worksheet setting
   * @param {string} [analysisViewType] - The analysis view type to render. One of: &#x27;trend&#x27;, &#x27;statisticsSummary&#x27;
  */
  public previewContent(
    {
      worksheetId,
      workstepId,
      height,
      width,
      scale,
      timezone,
      selector,
      dateRangeId,
      dateRangeFormula,
      validityDuration,
      reportId,
      contentId,
      summaryType,
      summaryValue,
      assetSelectionId,
      react,
      hideUncertainty,
      showUncertainty,
      analysisViewType
    } : {
      worksheetId: string,
      workstepId: string,
      height: number,
      width: number,
      scale?: number,
      timezone?: string,
      selector?: string,
      dateRangeId?: string,
      dateRangeFormula?: string,
      validityDuration?: string,
      reportId?: string,
      contentId?: string,
      summaryType?: PreviewContentSummaryTypeEnum,
      summaryValue?: string,
      assetSelectionId?: string,
      react?: boolean,
      hideUncertainty?: boolean,
      showUncertainty?: boolean,
      analysisViewType?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }

    if (workstepId === null || workstepId === undefined) {
      throw new Error("'workstepId' parameter required");
    }

    if (height === null || height === undefined) {
      throw new Error("'height' parameter required");
    }

    if (width === null || width === undefined) {
      throw new Error("'width' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/preview`;
    const urlTemplate = `${baseUrl}/content/preview`;

    const queryParams = {
      ['worksheetId']: worksheetId,      ['workstepId']: workstepId,      ['height']: height,      ['width']: width,      ['scale']: scale,      ['timezone']: timezone,      ['selector']: selector,      ['dateRangeId']: dateRangeId,      ['dateRangeFormula']: dateRangeFormula,      ['validityDuration']: validityDuration,      ['reportId']: reportId,      ['contentId']: contentId,      ['summaryType']: summaryType,      ['summaryValue']: summaryValue,      ['assetSelectionId']: assetSelectionId,      ['react']: react,      ['hideUncertainty']: hideUncertainty,      ['showUncertainty']: showUncertainty,      ['analysisViewType']: analysisViewType
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Redirect to the source worksheet for a given content image
   * @param {string} id - The Seeq ID for the content
   * @param {boolean} [noRedirect=false] - Set to true to receive the redirected URL as data rather than redirecting
  */
  public redirectToSourceWorksheet(
    {
      id,
      noRedirect
    } : {
      id: string,
      noRedirect?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/${encodeURIComponent(String(id))}/sourceUrl`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/{id}/sourceUrl`;

    const queryParams = {
      ['noRedirect']: noRedirect
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Update an asset selection
   * @param {string} id - The Seeq ID for the asset selection
  */
  public updateAssetSelection(
    body: models.AssetSelectionInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/asset-selections/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/asset-selections/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AssetSelectionOutputV1>;
  }

  /**
   * @summary Update a content item
   * @param {string} id - The Seeq ID for the content
   * @param {boolean} [clearCache=false] - Whether the content&#x27;s cache should be cleared. Useful to force regeneration of an image when content parameters have not changed
  */
  public updateContent(
    body: models.ContentInputV1,
    {
      id,
      clearCache
    } : {
      id: string,
      clearCache?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/{id}`;

    const queryParams = {
      ['clearCache']: clearCache
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ContentOutputV1>;
  }

  /**
   * @summary Update a date range
   * @param {string} id - The Seeq ID for the date range
  */
  public updateDateRange(
    body: models.DateRangeInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/date-ranges/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/date-ranges/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DateRangeOutputV1>;
  }

  /**
   * @summary Update the report's last viewed time
   * @param {string} id - The Seeq ID for the report
   * @param {string} [viewType=NORMAL] - The type of view being tracked
  */
  public updateLastViewedTime(
    {
      id,
      viewType
    } : {
      id: string,
      viewType?: UpdateLastViewedTimeViewTypeEnum
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/reports/lastViewed/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/reports/lastViewed/{id}`;

    const queryParams = {
      ['viewType']: viewType
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Update a row selection
   * @param {string} id - The Seeq ID for the row selection
  */
  public updateRowSelection(
    body: models.RowSelectionInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/content/row-selections/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/content/row-selections/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.RowSelectionOutputV1>;
  }

}

export const GetSchedulableStatisticsTypesEnum = {
    Scheduled: 'Scheduled',
    Live: 'Live',
    Static: 'Static',
    ConditionMonitor: 'ConditionMonitor',
    CustomAgentSchedule: 'CustomAgentSchedule'
} as const;

export type GetSchedulableStatisticsTypesEnum = typeof GetSchedulableStatisticsTypesEnum[keyof typeof GetSchedulableStatisticsTypesEnum];
export const GetSchedulableStatisticsSortByEnum = {
    AverageRunTime: 'AverageRunTime',
    TotalRunTime: 'TotalRunTime',
    WallClockRunTime: 'WallClockRunTime',
    Name: 'Name',
    Owner: 'Owner',
    ContentCount: 'ContentCount',
    LastViewedAt: 'LastViewedAt',
    NextRunTime: 'NextRunTime'
} as const;

export type GetSchedulableStatisticsSortByEnum = typeof GetSchedulableStatisticsSortByEnum[keyof typeof GetSchedulableStatisticsSortByEnum];
export const GetSchedulableSummaryStatEnum = {
    AverageRunTime: 'AverageRunTime'
} as const;

export type GetSchedulableSummaryStatEnum = typeof GetSchedulableSummaryStatEnum[keyof typeof GetSchedulableSummaryStatEnum];
export const PreviewContentSummaryTypeEnum = {
    DISCRETE: 'DISCRETE',
    AUTO: 'AUTO',
    NONE: 'NONE'
} as const;

export type PreviewContentSummaryTypeEnum = typeof PreviewContentSummaryTypeEnum[keyof typeof PreviewContentSummaryTypeEnum];
export const UpdateLastViewedTimeViewTypeEnum = {
    NORMAL: 'NORMAL',
    FIRSTTIME: 'FIRST_TIME',
    PDF: 'PDF'
} as const;

export type UpdateLastViewedTimeViewTypeEnum = typeof UpdateLastViewedTimeViewTypeEnum[keyof typeof UpdateLastViewedTimeViewTypeEnum];

export const sqContentApi = new sqContentApiClass();

export type sqContentApiEndpoints = {
  'archiveAssetSelection': {
    method: 'delete';
    path: '/content/asset-selections/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'archiveContent': {
    method: 'delete';
    path: '/content/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'archiveDateRange': {
    method: 'delete';
    path: '/content/date-ranges/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'archiveRowSelection': {
    method: 'delete';
    path: '/content/row-selections/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'clearImageCache': {
    method: 'delete';
    path: '/content/${encodeURIComponent(String(id))}/image';
    response: models.StatusMessageBase;
  };
  'createAssetSelection': {
    method: 'post';
    path: '/content/asset-selections';
    response: models.AssetSelectionOutputV1;
  };
  'createContent': {
    method: 'post';
    path: '/content';
    response: models.ContentOutputV1;
  };
  'createDateRange': {
    method: 'post';
    path: '/content/date-ranges';
    response: models.DateRangeOutputV1;
  };
  'createRowSelection': {
    method: 'post';
    path: '/content/row-selections';
    response: models.RowSelectionOutputV1;
  };
  'getAssetSelection': {
    method: 'get';
    path: '/content/asset-selections/${encodeURIComponent(String(id))}';
    response: models.AssetSelectionOutputV1;
  };
  'getContent': {
    method: 'get';
    path: '/content/${encodeURIComponent(String(id))}';
    response: models.ContentOutputV1;
  };
  'getContentItems': {
    method: 'get';
    path: '/content';
    response: models.GetContentItemsOutputV1;
  };
  'getContentItemsForDateRange': {
    method: 'get';
    path: '/content/date-ranges/${encodeURIComponent(String(id))}/content';
    response: models.GetContentItemsOutputV1;
  };
  'getContentsWithAllMetadata': {
    method: 'get';
    path: '/content/report/${encodeURIComponent(String(reportId))}';
    response: models.ContentWithMetadataListOutputV1;
  };
  'getDateRange': {
    method: 'get';
    path: '/content/date-ranges/${encodeURIComponent(String(id))}';
    response: models.DateRangeOutputV1;
  };
  'getDateRanges': {
    method: 'get';
    path: '/content/date-ranges';
    response: models.GetDateRangesOutputV1;
  };
  'getImage': {
    method: 'get';
    path: '/content/${encodeURIComponent(String(id))}/image';
    response: string;
  };
  'getNotifiableReports': {
    method: 'get';
    path: '/content/notifiableReports';
    response: models.NotifiableReportOutputListV1;
  };
  'getReactBlob': {
    method: 'get';
    path: '/content/${encodeURIComponent(String(id))}/react';
    response: any;
  };
  'getReportProductionStatus': {
    method: 'get';
    path: '/content/report/${encodeURIComponent(String(reportId))}/production-status';
    response: models.ReportProductionStatusOutputV1;
  };
  'getRowSelection': {
    method: 'get';
    path: '/content/row-selections/${encodeURIComponent(String(id))}';
    response: models.RowSelectionOutputV1;
  };
  'getSchedulableStatistics': {
    method: 'get';
    path: '/content/schedulable/metrics';
    response: models.SchedulableAdminListOutputV1;
  };
  'getSchedulableSummary': {
    method: 'get';
    path: '/content/schedulable/metrics/summary';
    response: models.SchedulableSummaryWeekOutputV1;
  };
  'previewContent': {
    method: 'get';
    path: '/content/preview';
    response: string;
  };
  'redirectToSourceWorksheet': {
    method: 'get';
    path: '/content/${encodeURIComponent(String(id))}/sourceUrl';
    response: string;
  };
  'updateAssetSelection': {
    method: 'post';
    path: '/content/asset-selections/${encodeURIComponent(String(id))}';
    response: models.AssetSelectionOutputV1;
  };
  'updateContent': {
    method: 'post';
    path: '/content/${encodeURIComponent(String(id))}';
    response: models.ContentOutputV1;
  };
  'updateDateRange': {
    method: 'post';
    path: '/content/date-ranges/${encodeURIComponent(String(id))}';
    response: models.DateRangeOutputV1;
  };
  'updateLastViewedTime': {
    method: 'post';
    path: '/content/reports/lastViewed/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'updateRowSelection': {
    method: 'post';
    path: '/content/row-selections/${encodeURIComponent(String(id))}';
    response: models.RowSelectionOutputV1;
  };
};

type ApiArchiveAssetSelectionResponse = models.StatusMessageBase;
type ApiarchiveAssetSelectionMutationParams = Parameters<typeof sqContentApi.archiveAssetSelection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.archiveAssetSelection>;

export function useApiArchiveAssetSelectionMutation(
  options?: Omit<UseMutationOptions<ApiArchiveAssetSelectionResponse, AxiosError<SeeqErrorData>,
    ApiarchiveAssetSelectionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveAssetSelectionResponse, AxiosError<SeeqErrorData>,
  ApiarchiveAssetSelectionMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveAssetSelectionMutationParams) =>
      sqContentApi.archiveAssetSelection(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveContentResponse = models.StatusMessageBase;
type ApiarchiveContentMutationParams = Parameters<typeof sqContentApi.archiveContent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.archiveContent>;

export function useApiArchiveContentMutation(
  options?: Omit<UseMutationOptions<ApiArchiveContentResponse, AxiosError<SeeqErrorData>,
    ApiarchiveContentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveContentResponse, AxiosError<SeeqErrorData>,
  ApiarchiveContentMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveContentMutationParams) =>
      sqContentApi.archiveContent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveDateRangeResponse = models.ArchiveOutputV1;
type ApiarchiveDateRangeMutationParams = Parameters<typeof sqContentApi.archiveDateRange> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.archiveDateRange>;

export function useApiArchiveDateRangeMutation(
  options?: Omit<UseMutationOptions<ApiArchiveDateRangeResponse, AxiosError<SeeqErrorData>,
    ApiarchiveDateRangeMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveDateRangeResponse, AxiosError<SeeqErrorData>,
  ApiarchiveDateRangeMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveDateRangeMutationParams) =>
      sqContentApi.archiveDateRange(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveRowSelectionResponse = models.StatusMessageBase;
type ApiarchiveRowSelectionMutationParams = Parameters<typeof sqContentApi.archiveRowSelection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.archiveRowSelection>;

export function useApiArchiveRowSelectionMutation(
  options?: Omit<UseMutationOptions<ApiArchiveRowSelectionResponse, AxiosError<SeeqErrorData>,
    ApiarchiveRowSelectionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveRowSelectionResponse, AxiosError<SeeqErrorData>,
  ApiarchiveRowSelectionMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveRowSelectionMutationParams) =>
      sqContentApi.archiveRowSelection(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiClearImageCacheResponse = models.StatusMessageBase;
type ApiclearImageCacheMutationParams = Parameters<typeof sqContentApi.clearImageCache> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.clearImageCache>;

export function useApiClearImageCacheMutation(
  options?: Omit<UseMutationOptions<ApiClearImageCacheResponse, AxiosError<SeeqErrorData>,
    ApiclearImageCacheMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiClearImageCacheResponse, AxiosError<SeeqErrorData>,
  ApiclearImageCacheMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiclearImageCacheMutationParams) =>
      sqContentApi.clearImageCache(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateAssetSelectionResponse = models.AssetSelectionOutputV1;
type ApicreateAssetSelectionMutationParams = Parameters<typeof sqContentApi.createAssetSelection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.createAssetSelection>;
type ApicreateAssetSelectionMutationVariables = models.AssetSelectionInputV1;

export function useApiCreateAssetSelectionMutation(
  options?: Omit<UseMutationOptions<ApiCreateAssetSelectionResponse, AxiosError<SeeqErrorData>,
    ApicreateAssetSelectionMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateAssetSelectionResponse, AxiosError<SeeqErrorData>,
  ApicreateAssetSelectionMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateAssetSelectionMutationVariables) =>
      sqContentApi.createAssetSelection(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateContentResponse = models.ContentOutputV1;
type ApicreateContentMutationParams = Parameters<typeof sqContentApi.createContent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.createContent>;
type ApicreateContentMutationVariables = models.ContentInputV1;

export function useApiCreateContentMutation(
  options?: Omit<UseMutationOptions<ApiCreateContentResponse, AxiosError<SeeqErrorData>,
    ApicreateContentMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateContentResponse, AxiosError<SeeqErrorData>,
  ApicreateContentMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateContentMutationVariables) =>
      sqContentApi.createContent(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateDateRangeResponse = models.DateRangeOutputV1;
type ApicreateDateRangeMutationParams = Parameters<typeof sqContentApi.createDateRange> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.createDateRange>;
type ApicreateDateRangeMutationVariables = models.DateRangeInputV1;

export function useApiCreateDateRangeMutation(
  options?: Omit<UseMutationOptions<ApiCreateDateRangeResponse, AxiosError<SeeqErrorData>,
    ApicreateDateRangeMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateDateRangeResponse, AxiosError<SeeqErrorData>,
  ApicreateDateRangeMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateDateRangeMutationVariables) =>
      sqContentApi.createDateRange(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateRowSelectionResponse = models.RowSelectionOutputV1;
type ApicreateRowSelectionMutationParams = Parameters<typeof sqContentApi.createRowSelection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.createRowSelection>;
type ApicreateRowSelectionMutationVariables = models.RowSelectionInputV1;

export function useApiCreateRowSelectionMutation(
  options?: Omit<UseMutationOptions<ApiCreateRowSelectionResponse, AxiosError<SeeqErrorData>,
    ApicreateRowSelectionMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateRowSelectionResponse, AxiosError<SeeqErrorData>,
  ApicreateRowSelectionMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateRowSelectionMutationVariables) =>
      sqContentApi.createRowSelection(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetAssetSelectionResponse = models.AssetSelectionOutputV1;
export function GetAssetSelectionQueryKey(
  params: Parameters<typeof sqContentApi.getAssetSelection>[0],
) {
  return ['sqContentApi', 'getAssetSelection', params] as const;
}

export function useApiGetAssetSelectionQuery(
  params: Parameters<typeof sqContentApi.getAssetSelection>[0],
  options?: Omit<UseQueryOptions<ApiGetAssetSelectionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAssetSelectionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAssetSelectionQueryKey(params),
    queryFn: () =>
      sqContentApi.getAssetSelection(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetContentResponse = models.ContentOutputV1;
export function GetContentQueryKey(
  params: Parameters<typeof sqContentApi.getContent>[0],
) {
  return ['sqContentApi', 'getContent', params] as const;
}

export function useApiGetContentQuery(
  params: Parameters<typeof sqContentApi.getContent>[0],
  options?: Omit<UseQueryOptions<ApiGetContentResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetContentResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetContentQueryKey(params),
    queryFn: () =>
      sqContentApi.getContent(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetContentItemsResponse = models.GetContentItemsOutputV1;
export function GetContentItemsQueryKey(
  params: Parameters<typeof sqContentApi.getContentItems>[0],
) {
  return ['sqContentApi', 'getContentItems', params] as const;
}

export function useApiGetContentItemsQuery(
  params: Parameters<typeof sqContentApi.getContentItems>[0],
  options?: Omit<UseQueryOptions<ApiGetContentItemsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetContentItemsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetContentItemsQueryKey(params),
    queryFn: () =>
      sqContentApi.getContentItems(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetContentItemsForDateRangeResponse = models.GetContentItemsOutputV1;
export function GetContentItemsForDateRangeQueryKey(
  params: Parameters<typeof sqContentApi.getContentItemsForDateRange>[0],
) {
  return ['sqContentApi', 'getContentItemsForDateRange', params] as const;
}

export function useApiGetContentItemsForDateRangeQuery(
  params: Parameters<typeof sqContentApi.getContentItemsForDateRange>[0],
  options?: Omit<UseQueryOptions<ApiGetContentItemsForDateRangeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetContentItemsForDateRangeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetContentItemsForDateRangeQueryKey(params),
    queryFn: () =>
      sqContentApi.getContentItemsForDateRange(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetContentsWithAllMetadataResponse = models.ContentWithMetadataListOutputV1;
export function GetContentsWithAllMetadataQueryKey(
  params: Parameters<typeof sqContentApi.getContentsWithAllMetadata>[0],
) {
  return ['sqContentApi', 'getContentsWithAllMetadata', params] as const;
}

export function useApiGetContentsWithAllMetadataQuery(
  params: Parameters<typeof sqContentApi.getContentsWithAllMetadata>[0],
  options?: Omit<UseQueryOptions<ApiGetContentsWithAllMetadataResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetContentsWithAllMetadataResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetContentsWithAllMetadataQueryKey(params),
    queryFn: () =>
      sqContentApi.getContentsWithAllMetadata(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDateRangeResponse = models.DateRangeOutputV1;
export function GetDateRangeQueryKey(
  params: Parameters<typeof sqContentApi.getDateRange>[0],
) {
  return ['sqContentApi', 'getDateRange', params] as const;
}

export function useApiGetDateRangeQuery(
  params: Parameters<typeof sqContentApi.getDateRange>[0],
  options?: Omit<UseQueryOptions<ApiGetDateRangeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetDateRangeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetDateRangeQueryKey(params),
    queryFn: () =>
      sqContentApi.getDateRange(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDateRangesResponse = models.GetDateRangesOutputV1;
export function GetDateRangesQueryKey(
  params: Parameters<typeof sqContentApi.getDateRanges>[0],
) {
  return ['sqContentApi', 'getDateRanges', params] as const;
}

export function useApiGetDateRangesQuery(
  params: Parameters<typeof sqContentApi.getDateRanges>[0],
  options?: Omit<UseQueryOptions<ApiGetDateRangesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetDateRangesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetDateRangesQueryKey(params),
    queryFn: () =>
      sqContentApi.getDateRanges(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetImageResponse = string;
export function GetImageQueryKey(
  params: Parameters<typeof sqContentApi.getImage>[0],
) {
  return ['sqContentApi', 'getImage', params] as const;
}

export function useApiGetImageQuery(
  params: Parameters<typeof sqContentApi.getImage>[0],
  options?: Omit<UseQueryOptions<ApiGetImageResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetImageResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetImageQueryKey(params),
    queryFn: () =>
      sqContentApi.getImage(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetNotifiableReportsResponse = models.NotifiableReportOutputListV1;
export function GetNotifiableReportsQueryKey(
  params: Parameters<typeof sqContentApi.getNotifiableReports>[0],
) {
  return ['sqContentApi', 'getNotifiableReports', params] as const;
}

export function useApiGetNotifiableReportsQuery(
  params: Parameters<typeof sqContentApi.getNotifiableReports>[0],
  options?: Omit<UseQueryOptions<ApiGetNotifiableReportsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetNotifiableReportsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetNotifiableReportsQueryKey(params),
    queryFn: () =>
      sqContentApi.getNotifiableReports(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetReactBlobResponse = any;
export function GetReactBlobQueryKey(
  params: Parameters<typeof sqContentApi.getReactBlob>[0],
) {
  return ['sqContentApi', 'getReactBlob', params] as const;
}

export function useApiGetReactBlobQuery(
  params: Parameters<typeof sqContentApi.getReactBlob>[0],
  options?: Omit<UseQueryOptions<ApiGetReactBlobResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetReactBlobResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetReactBlobQueryKey(params),
    queryFn: () =>
      sqContentApi.getReactBlob(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetReportProductionStatusResponse = models.ReportProductionStatusOutputV1;
export function GetReportProductionStatusQueryKey(
  params: Parameters<typeof sqContentApi.getReportProductionStatus>[0],
) {
  return ['sqContentApi', 'getReportProductionStatus', params] as const;
}

export function useApiGetReportProductionStatusQuery(
  params: Parameters<typeof sqContentApi.getReportProductionStatus>[0],
  options?: Omit<UseQueryOptions<ApiGetReportProductionStatusResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetReportProductionStatusResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetReportProductionStatusQueryKey(params),
    queryFn: () =>
      sqContentApi.getReportProductionStatus(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetRowSelectionResponse = models.RowSelectionOutputV1;
export function GetRowSelectionQueryKey(
  params: Parameters<typeof sqContentApi.getRowSelection>[0],
) {
  return ['sqContentApi', 'getRowSelection', params] as const;
}

export function useApiGetRowSelectionQuery(
  params: Parameters<typeof sqContentApi.getRowSelection>[0],
  options?: Omit<UseQueryOptions<ApiGetRowSelectionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetRowSelectionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetRowSelectionQueryKey(params),
    queryFn: () =>
      sqContentApi.getRowSelection(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSchedulableStatisticsResponse = models.SchedulableAdminListOutputV1;
export function GetSchedulableStatisticsQueryKey(
  params: Parameters<typeof sqContentApi.getSchedulableStatistics>[0],
) {
  return ['sqContentApi', 'getSchedulableStatistics', params] as const;
}

export function useApiGetSchedulableStatisticsQuery(
  params: Parameters<typeof sqContentApi.getSchedulableStatistics>[0],
  options?: Omit<UseQueryOptions<ApiGetSchedulableStatisticsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSchedulableStatisticsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSchedulableStatisticsQueryKey(params),
    queryFn: () =>
      sqContentApi.getSchedulableStatistics(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSchedulableSummaryResponse = models.SchedulableSummaryWeekOutputV1;
export function GetSchedulableSummaryQueryKey(
  params: Parameters<typeof sqContentApi.getSchedulableSummary>[0],
) {
  return ['sqContentApi', 'getSchedulableSummary', params] as const;
}

export function useApiGetSchedulableSummaryQuery(
  params: Parameters<typeof sqContentApi.getSchedulableSummary>[0],
  options?: Omit<UseQueryOptions<ApiGetSchedulableSummaryResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSchedulableSummaryResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSchedulableSummaryQueryKey(params),
    queryFn: () =>
      sqContentApi.getSchedulableSummary(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPreviewContentResponse = string;
export function PreviewContentQueryKey(
  params: Parameters<typeof sqContentApi.previewContent>[0],
) {
  return ['sqContentApi', 'previewContent', params] as const;
}

export function useApiPreviewContentQuery(
  params: Parameters<typeof sqContentApi.previewContent>[0],
  options?: Omit<UseQueryOptions<ApiPreviewContentResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiPreviewContentResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: PreviewContentQueryKey(params),
    queryFn: () =>
      sqContentApi.previewContent(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiRedirectToSourceWorksheetResponse = string;
export function RedirectToSourceWorksheetQueryKey(
  params: Parameters<typeof sqContentApi.redirectToSourceWorksheet>[0],
) {
  return ['sqContentApi', 'redirectToSourceWorksheet', params] as const;
}

export function useApiRedirectToSourceWorksheetQuery(
  params: Parameters<typeof sqContentApi.redirectToSourceWorksheet>[0],
  options?: Omit<UseQueryOptions<ApiRedirectToSourceWorksheetResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiRedirectToSourceWorksheetResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: RedirectToSourceWorksheetQueryKey(params),
    queryFn: () =>
      sqContentApi.redirectToSourceWorksheet(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUpdateAssetSelectionResponse = models.AssetSelectionOutputV1;
type ApiupdateAssetSelectionMutationParams = Parameters<typeof sqContentApi.updateAssetSelection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.updateAssetSelection>;

export function useApiUpdateAssetSelectionMutation(
  options?: Omit<UseMutationOptions<ApiUpdateAssetSelectionResponse, AxiosError<SeeqErrorData>,
    ApiupdateAssetSelectionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateAssetSelectionResponse, AxiosError<SeeqErrorData>,
  ApiupdateAssetSelectionMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateAssetSelectionMutationParams) =>
      sqContentApi.updateAssetSelection(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateContentResponse = models.ContentOutputV1;
type ApiupdateContentMutationParams = Parameters<typeof sqContentApi.updateContent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.updateContent>;

export function useApiUpdateContentMutation(
  options?: Omit<UseMutationOptions<ApiUpdateContentResponse, AxiosError<SeeqErrorData>,
    ApiupdateContentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateContentResponse, AxiosError<SeeqErrorData>,
  ApiupdateContentMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateContentMutationParams) =>
      sqContentApi.updateContent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateDateRangeResponse = models.DateRangeOutputV1;
type ApiupdateDateRangeMutationParams = Parameters<typeof sqContentApi.updateDateRange> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.updateDateRange>;

export function useApiUpdateDateRangeMutation(
  options?: Omit<UseMutationOptions<ApiUpdateDateRangeResponse, AxiosError<SeeqErrorData>,
    ApiupdateDateRangeMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateDateRangeResponse, AxiosError<SeeqErrorData>,
  ApiupdateDateRangeMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateDateRangeMutationParams) =>
      sqContentApi.updateDateRange(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateLastViewedTimeResponse = models.StatusMessageBase;
type ApiupdateLastViewedTimeMutationParams = Parameters<typeof sqContentApi.updateLastViewedTime> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.updateLastViewedTime>;

export function useApiUpdateLastViewedTimeMutation(
  options?: Omit<UseMutationOptions<ApiUpdateLastViewedTimeResponse, AxiosError<SeeqErrorData>,
    ApiupdateLastViewedTimeMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateLastViewedTimeResponse, AxiosError<SeeqErrorData>,
  ApiupdateLastViewedTimeMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiupdateLastViewedTimeMutationParams) =>
      sqContentApi.updateLastViewedTime(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateRowSelectionResponse = models.RowSelectionOutputV1;
type ApiupdateRowSelectionMutationParams = Parameters<typeof sqContentApi.updateRowSelection> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqContentApi.updateRowSelection>;

export function useApiUpdateRowSelectionMutation(
  options?: Omit<UseMutationOptions<ApiUpdateRowSelectionResponse, AxiosError<SeeqErrorData>,
    ApiupdateRowSelectionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateRowSelectionResponse, AxiosError<SeeqErrorData>,
  ApiupdateRowSelectionMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateRowSelectionMutationParams) =>
      sqContentApi.updateRowSelection(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
